import { j as A } from "./jsx-runtime-3tyXYecC.mjs";
import { createContext as P, useContext as G, useRef as m, useEffect as S, useCallback as M, useImperativeHandle as Q } from "react";
import { S as U } from "./selectable-box-group-CQY3NPT0.mjs";
import { g as I } from "./get-aria-describedby-G1wcWKF2.mjs";
import { S as L } from "./selectable-box-BqzFKtVw.mjs";
import { u as T } from "./use-rhf-wrapper-controller-DGFm3TD5.mjs";
import { t as W } from "./toggle-rhf-rules-Z1TdwfO9.mjs";
const D = P({
  deleteAllElementRefs: void 0,
  deleteElementRef: void 0,
  onBlur: void 0,
  onChange: void 0,
  registerElementRef: void 0,
  selectedValues: void 0,
  type: void 0,
  updateElementValues: void 0
});
function q(x) {
  const { inputId: o, isDisabled: c, onBlur: R, value: n } = x, {
    onBlur: h,
    onChange: u,
    registerElementRef: p,
    deleteElementRef: E,
    deleteAllElementRefs: s,
    type: g,
    selectedValues: i,
    updateElementValues: C
  } = G(D), a = m(null), b = (d, r) => {
    typeof u == "function" && u(r);
  }, f = () => {
    typeof h == "function" && h(), typeof R == "function" && R();
  }, v = (d) => {
    d && !c && p(d, o);
  };
  S(() => {
    a.current && c === !0 ? E(o) : (s(), p(a.current || null, o));
  }, [c]);
  const t = m(n);
  return S(() => {
    n !== t.current && (C(t.current), t.current = n);
  }, [n]), S(() => () => E(o), []), /* @__PURE__ */ A.jsx(
    L,
    {
      ...x,
      containerRef: v,
      inputId: o,
      isChecked: i == null ? void 0 : i.has(n),
      isDisabled: c,
      name: o,
      onBlur: f,
      onChange: b,
      type: g,
      value: n
    }
  );
}
const J = window.jQuery ? $.__("Please select at least one option.") : "Please select at least one option.";
function K({
  ariaDescribedby: x,
  children: o,
  control: c,
  defaultValue: R = "",
  errorMessageId: n,
  name: h,
  required: u,
  shouldUnregister: p,
  status: E,
  type: s = "radio",
  validate: g,
  ...i
}) {
  var y;
  const { field: C, fieldState: a } = T({
    control: c,
    defaultValue: R,
    name: h,
    rules: W({
      required: typeof u == "boolean" ? {
        message: J,
        value: !!u
      } : u,
      validate: g
    }),
    shouldUnregister: p
  }), { onBlur: b, onChange: f, ref: v } = C, t = m(/* @__PURE__ */ new Set()), d = (e) => {
    if (s === "radio") {
      t.current.clear(), t.current.add(e), f(e);
      return;
    }
    t.current.has(e) ? t.current.delete(e) : t.current.add(e), f([...t.current.values()]);
  }, r = m(/* @__PURE__ */ new Map()), V = (e, l) => {
    var k;
    if (t.current.size > 0) {
      for (const z of l.keys())
        if (t.current.has(z)) {
          (k = l.get(z)) == null || k.focus();
          return;
        }
    } else
      e.focus();
  }, j = M(() => {
    var e;
    if (r.current.size > 0) {
      const l = Array.from(r.current.values())[0];
      s === "radio" ? t.current.size > 0 ? (e = r.current.get(t.current.values().next().value)) == null || e.focus() : l.focus() : s === "checkbox" && V(l, r.current);
    }
  }, [s]), B = m(!1), _ = (e, l) => {
    e && !r.current.has(l) && r.current.set(l, e), B.current && r.current.size > 0 && (j(), B.current = !1);
  }, w = (e) => {
    t.current.has(e) && (t.current.delete(e), f([...t.current.values()]));
  }, F = () => {
    r.current.clear();
  }, H = (e) => {
    r.current.has(e) && r.current.delete(e);
  };
  return Q(v, () => ({
    focus: () => {
      r.current.size > 0 ? j() : B.current = !0;
    }
  })), /* @__PURE__ */ A.jsx(
    U,
    {
      ...i,
      ariaDescribedby: I(a.error ? n : void 0, x),
      errorMessage: n || (y = a.error) == null ? void 0 : y.message,
      status: a.error ? "error" : E,
      type: s,
      children: /* @__PURE__ */ A.jsx(
        D.Provider,
        {
          value: {
            deleteAllElementRefs: F,
            deleteElementRef: H,
            onBlur: b,
            onChange: d,
            registerElementRef: _,
            selectedValues: t.current,
            type: s,
            updateElementValues: w
          },
          children: o
        }
      )
    }
  );
}
K.SelectableBox = q;
export {
  K as S
};
//# sourceMappingURL=selectable-box-group-rhf-CXh5hphB.mjs.map
